import React from "react";
import styled from "styled-components";
import { Button } from "@vitalsource/vstui";
import Cover from "../../book/cover";

const Styled = {
  ForceHeightButton: styled(Button)`
    height: ${props => props.height};
    padding: 0;
    width: auto;
  `,
  ForceHeightBookCover: styled.img`
    height: ${props => props.height};
    width: auto;
  `,
  BlurredButton: styled(Button)`
    border: 0;
    border-radius: 0;
    display: inline-block;
    height: ${props => props.height};
    overflow: hidden;
    padding: 0;
    position: relative;
    width: ${props => props.width};
  `
};

const BookButton = ({ asset, onClick, width, height, forceHeight, blur }) => {
  if (forceHeight) {
    return (
      <Styled.ForceHeightButton
        naked
        onClick={() => {
          onClick(asset);
        }}
        height={height}
      >
        <Styled.ForceHeightBookCover
          height={height}
          src={asset.coverImageUrl}
          alt={asset.title}
        />
      </Styled.ForceHeightButton>
    );
  } else if (blur) {
    return (
      <Styled.BlurredButton
        height={height}
        width={width}
        onClick={() => {
          onClick(asset);
        }}
        naked
      >
        <Cover
          isbn={asset.vbid}
          width={parseInt(width)}
          height={parseInt(height)}
          altText={asset.title}
          loadBlurredImage={false}
          borderRadius={0}
        />
      </Styled.BlurredButton>
    );
  }
};

export default BookButton;
